import { WithLogic, withLogicContext } from 'App';
import { Loading } from 'common/components';
import Modal from 'common/components/Modal';
import BorderCrossingForm, { BorderCrossingFormModel } from 'common/forms/BorderCrossingForm';
import * as React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';

interface State {}

interface Props extends WithTranslation, WithLogic {
    visible: boolean;
    processing: boolean;
    onSubmit: (data: BorderCrossingFormModel) => void;
    onCancel: () => void;
}

class AllowanceBorderCrossingEdit extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {};
    }

    componentDidMount() {}
    render() {
        return (
            <Modal
                onCancel={this.props.onCancel}
                footer={null}
                title={<h1>{this.props.t('Allowance.borderCrossingForm.title')}</h1>}
                visible={this.props.visible}
            >
                {this.props.processing ? (
                    <Loading maxHeight="200" />
                ) : (
                    <BorderCrossingForm
                        lang={this.props.logic.auth().user().lang}
                        onCancel={this.props.onCancel}
                        onSubmit={this._onSubmit}
                    />
                )}
            </Modal>
        );
    }

    private _onSubmit = (data: BorderCrossingFormModel) => {
        this.props.onSubmit(data);
    };
}

export default withLogicContext(withTranslation()(AllowanceBorderCrossingEdit));
